import React from 'react'
import { useFormikContext } from 'formik'
import { EmployeeFormData } from '../../../services/api/employees'
import MaskedInput from 'antd-mask-input'

export const PhoneInput: React.FunctionComponent = () => {
  const { setFieldValue } = useFormikContext<EmployeeFormData>()

  const handleChange = (event: any): void => {
    const value = event.target.value as string
    setFieldValue('phoneNumber', value)
  }

  return (
    <MaskedInput
      name="phoneNumber"
      mask="+71111111111"
      onChange={handleChange}
    />
  )
}
